<template>
  <div class="hm-card" :style="{ marginTop, marginBottom }">
    <div v-if="$slots.top" class="hm-card__item hm-card__item--top">
      <slot name="top"></slot>
    </div>
    <div class="hm-card__item hm-card__item--body">
      <slot/>
    </div>
    <div v-if="$slots.bottom" class="hm-card__item hm-card__item--bottom">
      <slot name="bottom"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMCard',
  props: {
    marginTop: { type: String, default: '' },
    marginBottom: { type: String, default: '' },
  }
}
</script>

<style scoped>
.hm-card {
  border-radius: 16px;
  border: 1px solid #ebebeb;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-card__item {
  padding: 14px 12px 12px 20px;
}

.hm-card__item--top {
  border-bottom: 1px solid #e6e6e6;
}

.hm-card__item--bottom {
  border-top: 1px solid #e6e6e6;
}
</style>